// extracted by mini-css-extract-plugin
export default {"StatsInfoOverlay":"InfoOverlay_StatsInfoOverlay__lDnF3","InfoTrigger":"InfoOverlay_InfoTrigger__FM9qP"};